import './_quick-shop-product-card.scss';
import component from './quick-shop-product-card';

export default component;
